import { render } from "./CustomerResultList.vue?vue&type=template&id=5712c514"
import script from "./CustomerResultList.vue?vue&type=script&lang=js"
export * from "./CustomerResultList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__